import gql from 'graphql-tag';

export const PageSnapshotEffectiveSimple = gql`
  fragment PageSnapshotEffectiveSimple on pages_snapshots_effective {
    id
    name
    page_id
    is_active
  }
`;

export const PageSnapshotEffective = gql`
  fragment PageSnapshotEffective on pages_snapshots_effective {
    ...PageSnapshotEffectiveSimple
    definition
    chapter_responsible
    effective_at
    created_at
    updated_at
    created_by_user {
      name
      email
      picture
    }
    updated_by_user {
      name
      email
      picture
    }
    page {
      id
      tenant {
        id
      }
      content_category_id
    }
  }
  ${PageSnapshotEffectiveSimple}
`;

export const PageSnapshotPlannedSimple = gql`
  fragment PageSnapshotPlannedSimple on pages_snapshots_planned {
    created_at
    created_by_user {
      user_id
      name
      email
      picture
    }
    effective_at
    id
    is_active
    name
    page_id
    updated_by_user {
      user_id
      name
      email
      picture
    }
    updated_at
    reviews: pages_snapshots_reviews(
      order_by: { review: { created_at: desc } }
      limit: 1
    ) {
      review_id
    }
  }
`;

export const PageSnapshotPlanned = gql`
  fragment PageSnapshotPlanned on pages_snapshots_planned {
    ...PageSnapshotPlannedSimple
    chapter_responsible
    created_at
    definition
    effective_at
    page {
      id
      tenant {
        id
      }
      content_category_id
    }
    updated_at
  }
  ${PageSnapshotPlannedSimple}
`;

export const Review = gql`
  fragment Review on reviews {
    id
    created_at
    created_by_user {
      user_id
      picture
      name
      email
    }
    closed_by_user {
      user_id
      picture
      name
      email
    }
    is_approved
    is_rejected
    closed_at
    description
    summary_of_adjustments
    level
    review_comments {
      id
      content
    }
  }
`;

export const PageSnapshotSimple = gql`
  fragment PageSnapshotSimple on pages_snapshots {
    id
    name
    page_id
    effective_at
    is_active
    created_by_user {
      user_id
      name
      email
      picture
    }
    updated_by_user {
      user_id
      name
      email
      picture
    }
  }
`;

export const PageSnapshot = gql`
  fragment PageSnapshot on pages_snapshots {
    ...PageSnapshotSimple
    definition
    chapter_responsible
    created_at
    updated_at
    created_by_user {
      user_id
      name
      email
      picture
    }
    updated_by_user {
      user_id
      name
      email
      picture
    }
    page {
      id
      tenant {
        id
      }
      content_category_id
      content_category {
        id
        name
      }
      pages_locks_active(order_by: { updated_at: desc }, limit: 1) {
        id
        is_locked
        page_id
        updated_at
        updated_by_user {
          user_id
          name
        }
      }
    }
  }
  ${PageSnapshotSimple}
`;

export const PageSnapshotReview = gql`
  fragment PageSnapshotReview on pages_snapshots {
    pages_snapshots_reviews(
      order_by: { review: { created_at: desc } }
      limit: 1
    ) {
      id
      review {
        ...Review
      }
    }
    is_active
  }
  ${Review}
`;

export const PageSnapshotFull = gql`
  fragment PageSnapshotFull on pages_snapshots {
    ...PageSnapshot
    ...PageSnapshotReview
  }
  ${PageSnapshot}
  ${PageSnapshotReview}
`;
